import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface DeleteConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onConfirm: () => void;
  itemName?: string;
  isLoading?: boolean;
}

export default function DeleteConfirmationModal({
  open,
  onClose,
  setOpen,
  onConfirm,
  itemName = "this item",
  isLoading = false,
}: DeleteConfirmationModalProps) {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleClose = () => {
    if (!isLoading) {
      setOpen(false);
      onClose();
    }
  };

  return (
    <Modal
      className="modal deleteConfirmation_modal"
      open={open}
      onClose={handleClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Delete Confirmation</h2>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
              disabled={isLoading}
            >
              <CloseIcon />
            </button>
          </div>

          <div className="mb_20 hd_6">
            <h3>
              Are you sure you want to delete <strong>"{itemName}"</strong>?
            </h3>
            <p>This action cannot be undone.</p>
          </div>

          <div className="footer_btn_flex">
            <Button
              className="btn btn_grey"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              className="btn btn_primary"
              onClick={handleConfirm}
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

